export const parseToInteger = (value: string | number) =>
  isNaN(value as number) || value === '' || value === null ? 0 : parseInt(value as string);
